(() => {
  const MINIMUMS = {
    '713538175363': 2, // 2-month subscription
    '713538208131': 3  // 3-month subscription
  };

  const INPUT =
    'input.quantity__input[name="updates[]"][data-index]';

  let timer;

  function showTooltip(button, min) {
    document
      .querySelectorAll('.subscription-min-tooltip')
      .forEach(el => el.remove());

    const tip = document.createElement('div');

    tip.className = 'subscription-min-tooltip';
    tip.textContent =
      `Minimum ${min} packs for this subscription plan.`;

    Object.assign(tip.style, {
      position: 'fixed',
      zIndex: '999999',
      background: '#222',
      color: '#fff',
      padding: '7px 10px',
      borderRadius: '6px',
      fontSize: '12px',
      lineHeight: '1.3',
      maxWidth: '220px',
      textAlign: 'center',
      pointerEvents: 'none',
      boxShadow: '0 2px 8px rgba(0,0,0,.2)'
    });

    document.body.appendChild(tip);

    const b = button.getBoundingClientRect();
    const t = tip.getBoundingClientRect();

    tip.style.left =
      Math.max(
        8,
        Math.min(
          window.innerWidth - t.width - 8,
          b.left + b.width / 2 - t.width / 2
        )
      ) + 'px';

    tip.style.top =
      Math.max(8, b.top - t.height - 8) + 'px';

    setTimeout(() => tip.remove(), 2200);
  }

  async function applyRules() {
    try {
      const cart = await fetch('/cart.js')
        .then(response => response.json());

      document.querySelectorAll(INPUT).forEach(input => {
        const item =
          cart.items[Number(input.dataset.index) - 1];

        if (!item) return;

        const planId = String(
          item.selling_plan_allocation
            ?.selling_plan?.id || ''
        );

        const min = MINIMUMS[planId];

        if (!min) return;

        input.min = String(min);
        input.dataset.subscriptionMin = String(min);

        const minus = input
          .closest('quantity-input')
          ?.querySelector('button[name="minus"]');

        if (!minus) return;

        const qty = Number(input.value);
        const locked = qty <= min;

        minus.setAttribute(
          'aria-disabled',
          String(locked)
        );

        minus.style.opacity =
          locked ? '0.45' : '';

        minus.style.cursor =
          locked ? 'not-allowed' : '';

        minus.title = locked
          ? `Minimum ${min} packs for this subscription plan.`
          : '';
      });
    } catch (error) {
      console.warn(
        'Subscription minimums could not be applied.',
        error
      );
    }
  }

  function refresh(delay = 150) {
    clearTimeout(timer);
    timer = setTimeout(applyRules, delay);
  }

  document.addEventListener(
    'click',
    event => {
      const minus = event.target.closest(
        'quantity-input button[name="minus"]'
      );

      if (minus) {
        const input = minus
          .closest('quantity-input')
          ?.querySelector(INPUT);

        const min =
          Number(input?.dataset.subscriptionMin || 0);

        if (
          input &&
          min &&
          Number(input.value) <= min
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();

          showTooltip(minus, min);
          return;
        }
      }

      const quantityButton = event.target.closest(
        'quantity-input button[name="plus"],' +
        'quantity-input button[name="minus"]'
      );

      if (quantityButton) {
        refresh(300);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    event => {
      const input = event.target.closest?.(INPUT);

      if (!input) return;

      const min =
        Number(input.dataset.subscriptionMin || 0);

      if (
        min &&
        input.value !== '' &&
        Number(input.value) < min
      ) {
        input.value = String(min);

        const minus = input
          .closest('quantity-input')
          ?.querySelector('button[name="minus"]');

        if (minus) {
          showTooltip(minus, min);
        }
      }

      refresh(300);
    },
    true
  );

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (
          node.matches?.(INPUT) ||
          node.querySelector?.(INPUT)
        ) {
          refresh(100);
          return;
        }
      }
    }
  });

  function start() {
    applyRules();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }
})();